import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerRoundModel from "@/models/lucky-winner/lucky-winner-round"
import router from "@/router"
import store from "@/store"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import { onBeforeMount, reactive, ref } from "@vue/composition-api"

export default function useRoundInfo() {
  const { createRound, editRound, fetchRoundDetail, fetchRoundList, setRoundStatus } = luckyWinnerRoundModel()

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const roundInfoData = reactive({
    seq: 0,
    description: "",
    startdate: "",
    enddate: "",
    status: false,
  })

  const campaignId = ref(null)

  const isEdit = ref(false)

  const fetchRoundInfoFunc = () => {
    window.$loading(true)

    fetchRoundDetail.payload.RoundId = roundInfoData.seq

    store
      .dispatch('api/apiRequest', fetchRoundDetail)
      .then(response => {
        const respData = response.data.resp
        if (Object.keys(respData).length > 0) {
          roundInfoData.seq = respData.id
          roundInfoData.description = respData.description
          validFrom.date = resolveDate(respData.startdate)
          validFrom.time = resolveTime(respData.startdate)
          // validThrough.date = resolveDate(respData.enddate)
          // validThrough.time = resolveTime(respData.enddate)
          roundInfoData.status = respData.status
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const checkFormCreateOrEdit = () => {
    isEdit.value = false
    if (router.currentRoute.params.roundId) {
      isEdit.value = true
      roundInfoData.seq = router.currentRoute.params.roundId
    }
  }

  const onSubmitForm = () => {
    // window.$loading(true)
    const payload = {
      CampaignId: "",
      Description: "",
      Startdate: "",
      Starttime: "",
      // Enddate: "",
      // Endtime: "",
      Status: false
    }

    createRound.payload = payload
    editRound.payload = payload

    let payloadParam = {}
    if (isEdit.value == true) {
      payloadParam = editRound
      payloadParam.payload.Id = roundInfoData.seq
      payloadParam.payload.CampaignId = campaignId.value
      payloadParam.payload.Description = roundInfoData.description
      payloadParam.payload.Startdate = validFrom.date
      payloadParam.payload.Starttime = validFrom.time
      // payloadParam.payload.Enddate = validThrough.date
      // payloadParam.payload.Endtime = validThrough.time
      payloadParam.payload.Status = roundInfoData.status
    } else {
      payloadParam = createRound
      payloadParam.payload.CampaignId = campaignId.value
      payloadParam.payload.Description = roundInfoData.description
      payloadParam.payload.Startdate = validFrom.date
      payloadParam.payload.Starttime = validFrom.time
      // payloadParam.payload.Enddate = validThrough.date
      // payloadParam.payload.Endtime = validThrough.time
      payloadParam.payload.Status = roundInfoData.status
    }
    console.log(payloadParam)
    store
      .dispatch('api/apiRequest', payloadParam)
      .then(response => {
        if (response.status == "success") {
          openSuccessModal('ทำรายการสำเร็จ !', null, null, null, () => {
            router.replace(`/lucky-winner/campaign/${campaignId.value}/round/list`)
          })
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  onBeforeMount(() => {
    campaignId.value = router.currentRoute.params.campaignId

    checkFormCreateOrEdit()
    if (roundInfoData.seq) {
      fetchRoundInfoFunc()
    }
  })

  return {
    campaignId,
    roundInfoData,
    validFrom,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onSubmitForm,
  }
}
